import TextArea from '@/components/TextArea';
import { LabelButton, PrimaryButton } from '@/components/shared/Button';
import { useAuth } from '@/context/AuthContext';
import { InterviewState } from '@/enums/InterviewState';
import { UserRoles } from '@/enums/UsersRole';
import {
  ProffessionalPerspectivesModel,
  TrainingNeededModel,
} from '@/models/AnnualInterviewModel';
import { RootState } from '@/state';
import {
  saveAnnualInterviewAsync,
  updateAttitude,
  updateProffessionalPerspectives,
  updateTrainingNeeded,
} from '@/state/slices/annualInterviewSlice';
import { resetForm } from '@/state/slices/employeeSlice';
import { PaperAirplaneIcon } from '@heroicons/react/solid';
import { ThunkDispatch, AnyAction } from '@reduxjs/toolkit';
import { useFormik } from 'formik';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
const init: ProffessionalPerspectivesModel = {
  employeeProffessionalPerspectives: '',
  responsableProffessionalPerspectives: '',
};
function ProffessionalPerspectives() {
  const { user } = useAuth();

  const { t } = useTranslation();
  const dispatch: ThunkDispatch<RootState, any, AnyAction> = useDispatch();
  const annualInerview = useSelector(
    (state: RootState) => state.annualInterviews.annualInterview
  );

  const disabled = annualInerview.interviewState == InterviewState.Completed;
  const employeeProffessionalPerspectives = useSelector(
    (state: RootState) =>
      state.annualInterviews.annualInterview.employeeProffessionalPerspectives
  );
  const responsableProffessionalPerspectives = useSelector(
    (state: RootState) =>
      state.annualInterviews.annualInterview
        .responsableProffessionalPerspectives
  );
  const isTeamLeader = annualInerview.responsibleId == user?.id;
  const isEmployee = annualInerview.employeeId == user?.id;
  const formik = useFormik({
    initialValues: {
      ...init,
      employeeProffessionalPerspectives: employeeProffessionalPerspectives,
      responsableProffessionalPerspectives:
        responsableProffessionalPerspectives,
    },
    enableReinitialize: true,

    onSubmit: (values) => {
      dispatch(
        updateProffessionalPerspectives({ proffessionalPerspectives: values })
      );
    },
  });
  const handleSyncData = () => {
    dispatch(saveAnnualInterviewAsync(annualInerview));
  };
  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mx-2 flex flex-col gap-2">
        <div className="flex justify-between gap-4">
          <div className="group relative mb-6 w-full">
            <TextArea
              id="employeeProffessionalPerspectives"
              name="employeeProffessionalPerspectives"
              label={t(
                'annualInterviewForm.ProffessionalPerspectives.employeeProffessionalPerspectives'
              )}
              value={formik.values.employeeProffessionalPerspectives ?? ''}
              onChange={formik.handleChange}
              disabled={isTeamLeader || disabled}
            />
          </div>
          <div className="group relative mb-6 w-full">
            <TextArea
              id="responsableProffessionalPerspectives"
              name="responsableProffessionalPerspectives"
              label={t(
                'annualInterviewForm.ProffessionalPerspectives.responsableProffessionalPerspectives'
              )}
              value={formik.values.responsableProffessionalPerspectives ?? ''}
              onChange={formik.handleChange}
              disabled={!isTeamLeader || disabled}
            />
          </div>
        </div>
      </div>

      {!disabled && (
        <div className="flex justify-between">
          <LabelButton type="button" onClick={() => resetForm()}>
            {t('annualInterviewForm.ProffessionalPerspectives.reset')}
          </LabelButton>
          <PrimaryButton
            className="border-0 bg-purple-300 dark:bg-purple-500"
            type="button"
            onClick={handleSyncData}
          >
            <div className="flex items-center gap-2">
              <PaperAirplaneIcon className="h-4 w-4 rotate-90" />
              {t('annualInterviewForm.ProffessionalPerspectives.Sync')}
            </div>
          </PrimaryButton>
          <PrimaryButton
            type="submit"
            className="border-0 bg-primary-300 dark:bg-primary-500"
          >
            {t('annualInterviewForm.ProffessionalPerspectives.submit')}
          </PrimaryButton>
        </div>
      )}
    </form>
  );
}

export default ProffessionalPerspectives;
